// extracted by mini-css-extract-plugin
export var loadingSpinner = "b_b";
export var loadingText = "b_d";
export var spin = "b_c";